import { FilePurpose } from '../../libs/interfaces/filePurpose';
import { request } from '../../utils/request';
import { presignAndSaveToBucket } from '../fileUpload/uploadFile';

type MainPayload = {
  id: number;
  files: Array<{ file: File; is_default: boolean }>;
  authToken: string;
};

type ServerReqPayloadType = {
  file_url: string;
  file_type: string;
  is_default: boolean;
};
const sendPresignedUrlToServer = async (
  id: number,
  body: { files: ServerReqPayloadType[] },
  authToken: string
) =>
  request({
    method: 'POST',
    url: `/products/${id}/images/save`,
    formData: body,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });

// EACH IMAGE GOES THROUGH THIS PROCESS
const requestCycle = async ({
  file,
  authToken,
}: {
  file: File;
  authToken: string;
}) => {
  const res = await presignAndSaveToBucket({
    file,
    file_purpose: FilePurpose.PRODUCT_IMAGE,
    authToken,
  });
  return res;
};

export const addProductImage = async (body: MainPayload) => {
  try {
    const presignedUrls = await Promise.all(
      body.files.map((file) =>
        requestCycle({
          file: file.file,
          authToken: body.authToken,
        })
      )
    ).catch((err) => {
      console.error(err);
      throw new Error(`Images failed to upload, Please try again.`);
    });

    //REQUEST TO SAVE PRODUCT IMAGE TO THE BACKEND
    const serverReqPayload: ServerReqPayloadType[] = [];

    body.files.forEach((file, index) => {
      const { url: file_url, type: file_type } = presignedUrls[index];
      if (file_type && file_url) {
        serverReqPayload.push({
          is_default: file.is_default,
          file_type: presignedUrls[index]?.type as string,
          file_url: presignedUrls[index]?.url as string,
        });
      }
    });

    const response = await sendPresignedUrlToServer(
      body.id,
      { files: serverReqPayload },
      body.authToken
    );
    return response;
  } catch (error) {
    console.error('Error adding product image:', error);
    throw error;
  }
};
